import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/root/gastos-gub-uy/app/layouts/default.vue").then(m => m.default || m))
}